@if (immersiveViewService.error()) {
    <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-8 rounded-xl bg-white p-6 pointer-events-auto">
        <app-no-data-to-display
            iconSize="7x"
            textWidth="w-2/3"
            [displayedMessage]="errorMessage()" />

        @if (immersiveViewService.markerPosition()) {
            <app-button
                iconSize="xs"
                [icon]="['far', 'rectangle-history-circle-plus']"
                [label]="'immersiveView.openInGoogleMaps' | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="navigateToGoogleMaps()" />
        }
    </div>
} @else if (immersiveViewService.isLoading()) {
    <div class="absolute inset-0 flex items-center justify-center bg-white pointer-events-auto">
        <app-loading />
    </div>
}

@if (!immersiveViewService.error() && !immersiveViewService.isLoading()) {
    <button
        class="absolute top-3 right-3 immersive-view-indicator cursor-pointer pointer-events-auto"
        (click)="immersiveViewUiService.toggleFullscreen()">
        <fa-icon [icon]="immersiveViewUiService.isFullscreen() ? ['fas', 'minimize'] : ['fas', 'maximize']" />
    </button>
}
